import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { StaticLibraryEditView } from 'src/app/core/models/view-model/static-library-edit-view';
import { StaticLibraryViewModel } from './../../../core/models/regulation/static-regulation-library';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-static-library-dialog',
  templateUrl: './static-library-dialog.component.html',
  styleUrls: ['./static-library-dialog.component.scss']
})
export class StaticLibraryDialogComponent implements OnInit {

  @ViewChild('commentInput')
  commentInput!: ElementRef<HTMLInputElement>;
  @ViewChild('commentAutocomplete')
  commentAutocomplete!: MatAutocomplete;

  commentCntrl: FormControl = new FormControl();
  selectedComment: string[] = [];
  searchedComment: string[] = [];
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  isAllow = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: StaticLibraryEditView,
    private dialogRef: MatDialogRef<StaticLibraryDialogComponent>,
  ) { }

  ngOnInit(): void {
    const rtArray:any = [];
    this.data.comment.forEach(element => {
      const index = element.indexOf('[');
      const topicStr = index >= 0 ? element.substring(0, index - 1) : element;
      rtArray.push(topicStr);
    });
    this.selectedComment = rtArray;
  }

  removeComment(type: string): void {
    const index = this.selectedComment.indexOf(type);
    if (index >= 0) {
      this.selectedComment.splice(index, 1);
    }
  }

  addComment(event: MatChipInputEvent): void {
    if (!this.commentAutocomplete.isOpen) {
      //const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        this.selectedComment.push(value);
      }
      // Reset the input value
      // if (input) {
      //   input.value = '';
      // }
      event.chipInput!.clear();
      this.commentCntrl.setValue(null);
      this.commentCntrl.disable();
      this.commentCntrl.enable();
    }
  }

  selectComment(event: MatAutocompleteSelectedEvent): void {
    this.selectedComment.push(event.option.viewValue);
    this.commentInput.nativeElement.value = '';
    this.commentCntrl.setValue(null);
    this.commentCntrl.disable();
    this.commentCntrl.enable();
  }

  updateComment(): void {
    if (this.selectedComment.length === 0) {
      this.isAllow = false;
      setTimeout(() => {
        this.isAllow = true;
      }, 3000);
    } else {
      const obj = new StaticLibraryViewModel();
      obj.libraryId = this.data.libraryId;
      obj.updatesDbId = this.data.updatesDbId;
      obj.comment = this.selectedComment.toString();
      this.dialogRef.close(obj);
    }
  }
}
